module.exports = new __parcel__URL__("Project Status Hover.d317ca8f.svg").toString();